import React from "react";

import {
  FaPen,
  FaTrash,
} from "react-icons/fa";

import EmptyState from "../ui/EmptyState";

import {
  ActorIdentity,
  ClubAndWish,
  ContactBlock,
  GroupBadges,
  LinkedUsers,
} from "./ActorCells";

function InfoBlock({
  label,
  children,
}) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-slate-50 p-3 dark:border-slate-700 dark:bg-slate-800">
      <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
        {label}
      </div>

      <div className="mt-2">
        {children}
      </div>
    </div>
  );
}

export default function ActeursMobileCards({
  rows,
  loading,
  deleting,

  onEdit,
  onDelete,
  onManageGroups,
  onCreate,
}) {
  if (loading) {
    return (
      <div className="rounded-3xl border border-slate-200 bg-white py-14 text-center text-sm text-slate-500 shadow-sm xl:hidden dark:border-slate-800 dark:bg-slate-900">
        Chargement des acteurs...
      </div>
    );
  }

  if (!rows.length) {
    return (
      <div className="xl:hidden">
        <EmptyState
          onCreate={onCreate}
        />
      </div>
    );
  }

  return (
    <div className="space-y-3 xl:hidden">
      {rows.map((acteur) => (
        <article
          key={acteur.id}
          className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900"
        >
          <ActorIdentity
            acteur={acteur}
          />

          <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
            <InfoBlock label="Coordonnées">
              <ContactBlock
                acteur={acteur}
              />
            </InfoBlock>

            <InfoBlock label="Club / Souhait">
              <ClubAndWish
                acteur={acteur}
              />
            </InfoBlock>

            <InfoBlock label="Groupes">
              <GroupBadges
                groups={
                  acteur.Groups || []
                }
              />
            </InfoBlock>

            <InfoBlock label="Compte utilisateur">
              <LinkedUsers
                users={
                  acteur.Users || []
                }
              />
            </InfoBlock>
          </div>

          <div className="mt-5 flex flex-wrap gap-2">
            <button
              type="button"
              onClick={() =>
                onEdit(acteur)
              }
              className="inline-flex h-10 items-center gap-2 rounded-2xl bg-indigo-600 px-4 text-sm font-semibold text-white transition hover:bg-indigo-700"
            >
              <FaPen />
              Éditer
            </button>

            <button
              type="button"
              onClick={() =>
                onDelete(acteur.id)
              }
              disabled={deleting}
              className="inline-flex h-10 items-center gap-2 rounded-2xl bg-red-600 px-4 text-sm font-semibold text-white transition hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50"
            >
              <FaTrash />
              Supprimer
            </button>

            <button
              type="button"
              onClick={() =>
                onManageGroups(acteur)
              }
              className="inline-flex h-10 items-center gap-2 rounded-2xl border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
            >
              Groupes
            </button>
          </div>
        </article>
      ))}
    </div>
  );
}